import { render, staticRenderFns } from "./FenceDialog.vue?vue&type=template&id=5853a20a&scoped=true"
import script from "./FenceDialog.vue?vue&type=script&lang=js"
export * from "./FenceDialog.vue?vue&type=script&lang=js"
import style0 from "./FenceDialog.vue?vue&type=style&index=0&id=5853a20a&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5853a20a",
  null
  
)

export default component.exports